import React, { useCallback, useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useMediaQuery } from "@/lib/useMediaQuery";

export const MobileStatusStrip = ({ children, id, label = "Ticket statuses", T = value => value }) => {
  const mobile = useMediaQuery("(max-width: 767px)");
  const viewport = useRef(null);
  const [edges, setEdges] = useState({ left: false, right: false });
  const measure = useCallback(() => {
    const el = viewport.current;
    const next = el && mobile ? { left: el.scrollLeft > 1, right: el.scrollLeft + el.clientWidth < el.scrollWidth - 1 } : { left: false, right: false };
    setEdges(previous => previous.left === next.left && previous.right === next.right ? previous : next);
  }, [mobile]);
  useEffect(() => {
    const el = viewport.current;
    if (!el) return;
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    [...el.children].forEach(child => observer.observe(child));
    return () => observer.disconnect();
  }, [measure, children]);
  const move = direction => viewport.current?.scrollBy({ left: direction * Math.max(120, viewport.current.clientWidth * 0.75), behavior: "smooth" });
  const arrowClass = "flex h-8 w-7 shrink-0 items-center justify-center rounded-sm text-emerald-800 transition-colors hover:bg-emerald-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-emerald-700";
  return <div className="flex min-w-0 max-w-full items-center gap-1" role="group" aria-label={label} data-testid={id}>
    {mobile && edges.left && <button type="button" className={arrowClass} onClick={() => move(-1)} aria-label={T("Scroll statuses left")} title={T("Scroll statuses left")} data-testid={`${id}-left`}><ChevronLeft className="h-4 w-4" /></button>}
    <div ref={viewport} onScroll={measure} className="portal-status-strip min-w-0 flex-1" data-horizontal-scroll="status" data-testid={`${id}-viewport`}>
      {children}
    </div>
    {mobile && edges.right && <button type="button" className={arrowClass} onClick={() => move(1)} aria-label={T("Scroll statuses right")} title={T("Scroll statuses right")} data-testid={`${id}-right`}><ChevronRight className="h-4 w-4" /></button>}
  </div>;
};